"use client";

import { blogQuery } from "@/api/blog";
import { useQuery } from "@tanstack/react-query";

// ----------------------------------------------------------------------------

export type ISubCategoryDataResponse = {
  id: number;
  attributes: {
    name?: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
  };
}[];

/**
 * Handle to get leadeship sub-category values
 * @param data
 * @returns Array of string
 */
const getSubCategoryValue = (data: ISubCategoryDataResponse) => {
  const subCategories = data.map((item) => item?.attributes?.name);
  return subCategories.filter((item) => item !== undefined && item !== null);
};

const useBlogsSubCategory = () => {
  // Leadership Subcategory Data: By Function
  const { data: blogsByFunctions } = useQuery({
    ...blogQuery.getBlogsSubCategory("blogs-by-functions"),
    select: (data) => {
      return getSubCategoryValue(data);
    },
  });

  // Leadership Subcategory Data: By Process
  const { data: blogsByProcesses } = useQuery({
    ...blogQuery.getBlogsSubCategory("blogs-by-processes"),
    select: (data) => {
      return getSubCategoryValue(data);
    },
  });

  // Leadership Subcategory Data: By Role
  const { data: blogsByRoles } = useQuery({
    ...blogQuery.getBlogsSubCategory("blogs-by-roles"),
    select: (data) => {
      return getSubCategoryValue(data);
    },
  });

  return { blogsByFunctions, blogsByProcesses, blogsByRoles };
};

export default useBlogsSubCategory;
